<template>
  <div>
    <div id="wrapper">
      <div id="inner1">
        <app_header />
      </div>
      <div id="inner2">
        <router-view />
      </div>
      <div id="footer">
        <app_footer />
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: "MBCorpoATitleCond-Regular", "DaimlerCS-Regular", Arial, "Helvetica Neue", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import app_header from './components/HeaderView.vue'
import app_footer from './components/FooterView.vue'
export default defineComponent({
  name: "App",
  components: {
    app_header,
    app_footer
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>

<style>
#wrapper {
  margin-left: auto;
  margin-right: auto;
  height: auto;
  width: auto;
}

#inner1 {
  float: left;
}

#inner2 {
  clear: left;
  height: 88vh;
  overflow: auto;
}

#footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>